/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AdjacentNoticesDto } from '../../models/adjacent-notices-dto';

export interface NoticeControllerFindAdjacentV1$Params {

/**
 * 공지사항 ID
 */
  id: string;
}

export function noticeControllerFindAdjacentV1(http: HttpClient, rootUrl: string, params: NoticeControllerFindAdjacentV1$Params, context?: HttpContext): Observable<StrictHttpResponse<AdjacentNoticesDto>> {
  const rb = new RequestBuilder(rootUrl, noticeControllerFindAdjacentV1.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AdjacentNoticesDto>;
    })
  );
}

noticeControllerFindAdjacentV1.PATH = '/api/v1/notice/{id}/adjacent';
